export default {
  mutations: {
    SET_PAYLOAD: 'SET_TOKEN',
    REMOVE_TOKEN: 'REMOVE_TOKEN'
  },
  getters: {
    GET_PAYLOAD: 'GET_PAYLOAD'
  },
  actions: {
    REGISTER: 'REGISTER',
    LOGOUT: 'LOGOUT',
    LOGIN: 'LOGIN',
    REFRESH_TOKEN: 'REFRESH_TOKEN'
  }
}
